import { observer } from 'mobx-react-lite';
import { PudoListItemContainer, PudoRow } from './pudo-list-item.styles';
import CustomSkeleton from '../../../common/skeletons/custom-skeleton-component';

interface Props {
  withDetails?: boolean; // max weight and distance
  onChoose?: () => void;
}

const PudoListItemSkeleton = ({ withDetails, onChoose }: Props) => (
  <PudoListItemContainer
    $withDetails={withDetails}
    onClick={() => {
      onChoose && onChoose();
    }}>
    <PudoRow>
      <CustomSkeleton height='2rem' />
      <CustomSkeleton
        width='60%'
        height='2rem'
      />
    </PudoRow>

    <PudoRow>
      <CustomSkeleton height='2rem' />
      <CustomSkeleton
        width='60%'
        height='2rem'
      />
    </PudoRow>
    <PudoRow>
      <CustomSkeleton height='2rem' />
      <CustomSkeleton
        width='60%'
        height='2rem'
      />
    </PudoRow>
  </PudoListItemContainer>
);

export default observer(PudoListItemSkeleton);
